/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/303-loop2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.901 2.599A8 8 0 000 8h1.5a6.5 6.5 0 0111.339-4.339L10.5 6H16V.5l-2.099 2.099zM14.5 8a6.5 6.5 0 01-11.339 4.339L5.5 10H0v5.5l2.099-2.099A8 8 0 0016 8h-1.5z"/>'
  }
})
